import { render, staticRenderFns } from "./AppView.vue?vue&type=template&id=53fe82cd&scoped=true"
import script from "./AppView.vue?vue&type=script&lang=js"
export * from "./AppView.vue?vue&type=script&lang=js"
import style0 from "./AppView.vue?vue&type=style&index=0&id=53fe82cd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53fe82cd",
  null
  
)

export default component.exports